"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "What types of cookies does FETC use on this website?",
  answer: "We use essential cookies for site functionality, preference cookies to remember your settings, and analytical cookies to understand how visitors interact with our technical content. This helps us improve our enterprise solutions and user experience."
}, {
  question: "How does FETC use Google Analytics data?",
  answer: "We use Google Analytics to track anonymized data such as page views, session duration, and bounce rates. This information is used exclusively to optimize our site performance and ensure our engineering insights reach the right audience."
}, {
  question: "Can I opt-out of tracking and analytics?",
  answer: "Yes. You can manage your preferences through our cookie consent banner or by adjusting your browser settings. While essential cookies are necessary for the site to function, analytical tracking is entirely optional."
}, {
  question: "Is my personal data shared with third-party advertisers?",
  answer: "No. FETC does not sell your data or share it with third-party advertisers for marketing purposes. Our analytics are strictly for internal performance monitoring and improving our service delivery to clients."
}, {
  question: "How long is the tracking data stored?",
  answer: "Analytical data is typically retained for a period of 26 months before being automatically deleted. We ensure all data handling complies with Data Rights & Compliance Requests and our internal corporate governance policies."
}];
export default function CookiesAndAnalytics() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="261062" id="cookies-and-analytics" className="bg-[#0F172A] py-14 md:py-18 lg:py-20 min-h-screen flex items-center scroll-mt-[120px] snap-start overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 w-full" ref={ref}>
        <div className={`flex flex-col items-center text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-default font-bold text-[#F8FAFC] mb-4">
            Cookies & Analytics
          </h2>
          <p className="text-lg md:text-xl text-[#CBD5E1] font-default max-w-3xl leading-relaxed">
            Transparent information about how we use data to enhance your experience and maintain our high standards of digital security.
          </p>
        </div>

        <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 transition-all duration-700 delay-150 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {faqs.map((faq, i) => <div key={i} data-index={i} className="bg-[#142033] p-8 md:p-10 rounded-lg border border-[rgba(19,184,200,0.18)] hover:border-[#13B8C8]/40 transition-all duration-300 shadow-lg flex flex-col gap-4">
              <h3 className="text-xl font-semibold text-[#F8FAFC]">
                {faq.question}
              </h3>
              <p className="text-[#CBD5E1] font-sans text-base md:text-lg leading-relaxed">
                {faq.answer}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}